import AlertConstants from "./AlertConstants.js";
const loadOperationChecks = (experimentId, uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.LOAD_OPERATION_CHECKS,
    experimentId,
    uniqueAppModuleInstanceKey
  };
};
const loadingOperationChecks = (uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.LOADING_OPERATION_CHECKS,
    uniqueAppModuleInstanceKey
  };
};
const loadedOperationChecks = (operationAlertResult, uniqueAppModuleInstanceKey, error = "") => {
  return {
    type: AlertConstants.LOADED_OPERATION_CHECKS,
    operationAlertResult,
    uniqueAppModuleInstanceKey,
    error
  };
};
const loadExperimentJournal = (experimentId, uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.LOAD_EXPERIMENT_JOURNAL,
    experimentId,
    uniqueAppModuleInstanceKey
  };
};
const loadingExperimentJournal = (uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.LOADING_EXPERIMENT_JOURNAL,
    uniqueAppModuleInstanceKey
  };
};
const loadedExperimentJournal = (experimentJournalResult, uniqueAppModuleInstanceKey, error = "") => {
  return {
    type: AlertConstants.LOADED_EXPERIMENT_JOURNAL,
    experimentJournalResult,
    uniqueAppModuleInstanceKey,
    error
  };
};
const loadQualityAlerts = (experimentId, uniqueAppModuleInstanceKey, workspaceId) => {
  return {
    type: AlertConstants.LOAD_QUALITY_ALERTS,
    experimentId,
    uniqueAppModuleInstanceKey,
    workspaceId
  };
};
const loadingQualityAlerts = (uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.LOADING_QUALITY_ALERTS,
    uniqueAppModuleInstanceKey
  };
};
const loadedQualityAlerts = (qualityAlerts, uniqueAppModuleInstanceKey, error = "") => {
  return {
    type: AlertConstants.LOADED_QUALITY_ALERTS,
    uniqueAppModuleInstanceKey,
    qualityAlerts,
    error
  };
};
const resolveQualityAlerts = (experimentId, alertEngageData, uniqueAppModuleInstanceKey, workspaceId) => {
  return {
    type: AlertConstants.RESOLVE_QUALITY_ALERTS,
    experimentId,
    uniqueAppModuleInstanceKey,
    alertEngageData,
    workspaceId
  };
};
const resolvingQualityAlerts = (uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.RESOLVING_QUALITY_ALERTS,
    uniqueAppModuleInstanceKey
  };
};
const resolvedQualityAlerts = (engageResult, uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.RESOLVED_QUALITY_ALERTS,
    uniqueAppModuleInstanceKey,
    engageResult
  };
};
const toggleViewAndResolveAlerts = (openPanel, uniqueAppModuleInstanceKey) => {
  return {
    type: AlertConstants.TOGGLE_VIEW_AND_RESOLVE_ALERTS,
    uniqueAppModuleInstanceKey,
    openPanel
  };
};
export {
  loadExperimentJournal,
  loadOperationChecks,
  loadQualityAlerts,
  loadedExperimentJournal,
  loadedOperationChecks,
  loadedQualityAlerts,
  loadingExperimentJournal,
  loadingOperationChecks,
  loadingQualityAlerts,
  resolveQualityAlerts,
  resolvedQualityAlerts,
  resolvingQualityAlerts,
  toggleViewAndResolveAlerts
};
//# sourceMappingURL=AlertActions.js.map
